module.exports = __webpack_public_path__ + "static/media/logosmalldt4v2.3ffa8600.png";